import React from "react";
import { Box, Typography, Link, Grid } from "@mui/material";
import { useLanguage } from "../../../services/localization/LanguageContex";

function Footer() {
  const { t } = useLanguage();
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        // backgroundColor: (theme) => theme.palette.mode === "light" ? "#f5f5f5" : "#1c1c1c",
        backgroundColor: "#f5f5f5"
      }}
    >
      {/* First Row */}
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        {/* Left Column: Bhutan Foundation */}
        <Grid item xs={12} sm={6} textAlign="center">
          <Link
            href="https://wangsel.education.gov.bt/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="text.secondary"
            variant="h6"
          >
            {t("Wangsel Institute")}
            {/* དབང་གསལ་སྤེལ་ཁང་། */}
          </Link>
        </Grid>

        {/* Right Column: App Store Links */}
        <Grid item xs={12} sm={6} textAlign="center">
          <Box display="flex" justifyContent="center" alignItems="center" gap={2} flexWrap="wrap">
            <Link
              href="https://play.google.com/store/apps/details?id=com.bhutansignlanguage.bhsl&hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                sx={{ height: 40 }}
              />
            </Link>

            <Link
              href="https://apps.apple.com/us/app/bhutanese-sign-language/id6472443124"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                sx={{ height: 40 }}
              />
            </Link>
          </Box>
        </Grid>
      </Grid>

      {/* Second Row: Copyright */}
      <Box textAlign="center" mt={3}>
        <Typography variant="body2" color="text.secondary">
          {t("Copyright")}© {new Date().getFullYear()} {t("Wangsel Institute")}

          {/* པར་དབང་ © 2025 དབང་གསལ་སྤེལ་ཁང་། */}
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
